/* =========================
   🧠 等待 Google Maps 加载
========================= */
function waitForGoogle(callback) {
  if (window.google && window.google.maps) {
    callback();
  } else {
    setTimeout(() => waitForGoogle(callback), 100);
  }
}

if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template")?.content?.firstElementChild?.cloneNode(
            true,
          );

        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.onSelectedStoreChanged = this.onSelectedStoreChanged.bind(this);

        this.geocoder = null;

        window.addEventListener(
          "selected-store:changed",
          this.onSelectedStoreChanged,
        );

        this.fetchAvailability(this.dataset.variantId);
      }

      disconnectedCallback() {
        window.removeEventListener(
          "selected-store:changed",
          this.onSelectedStoreChanged,
        );
      }

      onSelectedStoreChanged() {
        this.restoreSelectedStore();
        this.updatePickupText();
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) rootUrl += "/";

        const url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(url)
          .then((res) => res.text())
          .then((text) => {
            const html = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");

            this.renderPreview(html);
          })
          .catch(() => {
            const btn = this.querySelector("button");
            if (btn) btn.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.dataset.variantId = variant.id;
          this.dataset.sku = variant.sku || "";
          this.fetchAvailability(variant.id);
        } else {
          this.dataset.variantId = variant?.id || "";
          this.dataset.sku = variant?.sku || "";
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderError() {
        this.innerHTML = "";
        if (this.errorHtml) this.appendChild(this.errorHtml);
        this.querySelector("button")?.addEventListener(
          "click",
          this.onClickRefreshList,
        );
      }

      renderPreview(sectionInnerHTML) {
        const oldDrawer = document.querySelector("pickup-availability-drawer");
        if (oldDrawer) oldDrawer.remove();

        const preview = sectionInnerHTML.querySelector(
          "pickup-availability-preview",
        );

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        if (this.dataset.pickupOnly === "true") {
          preview.querySelector("[data-home-delivery-status]")?.remove();
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute("available", "");

        const newDrawer = sectionInnerHTML.querySelector(
          "pickup-availability-drawer",
        );
        document.body.appendChild(newDrawer);

        const buttons = this.querySelectorAll("button");

        buttons.forEach((button) => {
          button.addEventListener("click", (evt) => {
            console.log(evt);
            newDrawer.show(evt.target);

            setTimeout(() => {
              this.initPickupSearch();
              this.autoLocate();
            }, 0);
          });
        });
        this.updateHomeDeliveryStatus();
        this.updatePickupText();
      }
      /* =========================
         🔍 搜索逻辑
      ========================= */
      initPickupSearch() {
        setTimeout(() => {
          const input = document.getElementById("pickup-search-input");
          const btn = document.getElementById("pickup-search-btn");
          const listEl = document.querySelector(".pickup-availability-list");

          if (!input || !btn || !listEl) return;

          // 防重复绑定 input
          if (!input.dataset.binded) {
            input.dataset.binded = "true";
            input.addEventListener("input", () => {
              if (!input.value.trim()) {
                listEl
                  .querySelectorAll(".search-result")
                  .forEach((el) => el.remove());
              }
            });
          }

          // 防重复绑定 button
          if (btn.dataset.binded) return;
          btn.dataset.binded = "true";

          waitForGoogle(async () => {
            if (!this.geocoder) this.geocoder = new google.maps.Geocoder();

            btn.addEventListener("click", async () => {
              const address = input.value.trim();
              if (!address) {
                listEl
                  .querySelectorAll(".search-result")
                  .forEach((el) => el.remove());
                return;
              }

              try {
                const { lat, lng } = await this.geocodeAddress(address);
                const nearbyOutlets = await this.fetchNearbyOutlets({
                  sku: this.dataset.sku,
                  quantity: 1,
                  lat,
                  lon: lng,
                  count: 5,
                });

                this.renderNearbyOutlets(listEl, nearbyOutlets);
              } catch (err) {
                console.error(err);
                alert("Failed to fetch nearby outlets");
              }
            });
          });
        }, 300);

        this.bindStoreRadio();
        this.restoreSelectedStore();
      }

      bindStoreRadio() {
        const listEl = document.querySelector(".pickup-availability-list");

        if (!listEl || listEl.dataset.radioBinded) return;
        listEl.dataset.radioBinded = "true";

        listEl.addEventListener("change", (e) => {
          const input = e.target.closest(".select-store-input");
          if (!input) return;

          const storeData = {
            name: input.value,
            pickuptime: input.dataset.pickuptime,
            siteup: input.dataset.siteup,
          };

          localStorage.setItem("selectedStore", JSON.stringify(storeData));
          window.dispatchEvent(
            new CustomEvent("selected-store:changed", {
              detail: { store: storeData, source: "pdp" },
            }),
          );
          this.updatePickupText();
          // 选择门店后关闭弹窗
          document.querySelector("pickup-availability-drawer")?.hide();
          console.log("选中门店:", storeData);
        });
      }
      restoreSelectedStore() {
        const saved = localStorage.getItem("selectedStore");
        if (!saved) return;

        const data = JSON.parse(saved);

        const inputs = document.querySelectorAll(".select-store-input");

        inputs.forEach((input) => {
          if (input.value === data.name) {
            input.checked = true;
          }
        });
      }
      /* =========================
         📍 地址转经纬度
      ========================= */
      geocodeAddress(address) {
        return new Promise((resolve, reject) => {
          this.geocoder.geocode({ address }, (results, status) => {
            if (status !== "OK") {
              reject(status);
              return;
            }

            const loc = results[0].geometry.location;
            resolve({
              lat: loc.lat(),
              lng: loc.lng(),
            });
          });
        });
      }

      /* =========================
         📡 调接口
      ========================= */
      async fetchNearbyOutlets(params) {
        const { sku, quantity = 1, lat, lon, count = 5 } = params;

        try {
          const res = await fetch(
            "https://shopify-big.bigcaring.com.my/api/outlet/available",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ sku, quantity, lat, lon, count }),
            },
          );

          const data = await res.json();
          return data.available || data.avaliable || [];
        } catch (err) {
          console.error(err);
          return [];
        }
      }

      /* =========================
         📍 自动定位（可选）
      ========================= */
      async autoLocate() {
        try {
          const pos = await this.getUserLocation();
          const listEl = document.querySelector(".pickup-availability-list");
          if (!listEl) return;

          const nearbyOutlets = await this.fetchNearbyOutlets({
            sku: this.dataset.sku,
            lat: pos.latitude,
            lon: pos.longitude,
          });

          this.renderNearbyOutlets(listEl, nearbyOutlets);
        } catch (err) {
          console.warn("定位失败", err);
        }
      }

      getUserLocation() {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject();
            return;
          }

          navigator.geolocation.getCurrentPosition((pos) => {
            resolve({
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
            });
          }, reject);
        });
      }

      normalizeStoreName(name) {
        return String(name || "")
          .trim()
          .replace(/\s+/g, " ")
          .toLowerCase();
      }

      getStoreMatchKey(siteup, storeName) {
        const siteCode = String(siteup || "").trim();
        if (siteCode) return `site:${siteCode}`;

        const normalizedName = this.normalizeStoreName(storeName);
        return normalizedName ? `name:${normalizedName}` : "";
      }

      getOutletMatchKey(outlet) {
        return this.getStoreMatchKey(outlet?.site_code, outlet?.outlet_title);
      }

      buildStoreMap(listEl) {
        const shopifyLis = Array.from(
          listEl.querySelectorAll(
            ".pickup-availability-list__item[data-store-name]",
          ),
        );
        const shopifyMap = {};

        shopifyLis.forEach((li) => {
          const key = this.getStoreMatchKey(
            li.dataset.siteup,
            li.dataset.storeName,
          );

          if (!key) return;
          if (!shopifyMap[key]) shopifyMap[key] = li;
          else li.remove();
        });

        return shopifyMap;
      }

      renderNearbyOutlets(listEl, outlets) {
        const storeMap = this.buildStoreMap(listEl);
        const renderedKeys = new Set();
        const finalHTML = [];

        outlets.forEach((outlet) => {
          const key = this.getOutletMatchKey(outlet);
          if (!key || renderedKeys.has(key)) return;
          renderedKeys.add(key);

          const source = storeMap[key] || Object.values(storeMap).find((li) =>
            (!li.dataset.siteup || !outlet.site_code) &&
            this.normalizeStoreName(li.dataset.storeName) ===
              this.normalizeStoreName(outlet.outlet_title),
          );
          finalHTML.push(this.renderOutletItem(outlet, source));

          if (source) {
            delete storeMap[this.getStoreMatchKey(
              source.dataset.siteup,
              source.dataset.storeName,
            )];
          }
        });

        Object.values(storeMap).forEach((li) => finalHTML.push(li.outerHTML));
        listEl.innerHTML = finalHTML.join("");
        this.restoreSelectedStore();
      }

      escapeOutletText(value) {
        const element = document.createElement("span");
        element.textContent = String(value || "");
        return element.innerHTML.replace(/"/g, "&quot;");
      }

      renderOutletItem(outlet, source) {
        const name = this.escapeOutletText(outlet?.outlet_title?.trim());
        const siteup = this.escapeOutletText(String(outlet?.site_code || "").trim());
        const location = this.escapeOutletText(outlet?.location);
        const inventory = Number(outlet?.inventory);
        const isAvailable = Number.isFinite(inventory) && inventory >= 1;

        const template = document.createElement("template");
        template.innerHTML = `
          <li class="pickup-availability-list__item search-result" data-store-name="${name}" data-siteup="${siteup}">
            <label class="store-item-label">
              <input type="radio" name="pickup-store" class="select-store-input" value="${name}" data-siteup="${siteup}">
              <div class="store-content">
                <h3 class="h4"><span class="fake-checkbox"></span>${name}</h3>
                <p class="pickup-availability-preview caption-large">
                  <span class="svg-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-tick" viewBox="0 0 20 20">
                    <path fill="#108043" stroke="#fff" d="m16.136 6.979.003-.004a1.499 1.499 0 0 0-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 1 0 3.94 12.06l2.999 3c.289.29.675.44 1.1.439h.019a1.5 1.5 0 0 0 1.08-.522z"></path>
                  </svg>
                </span>
                  Pickup available, Usually ready in 3 hours
                </p>
                <address class="pickup-availability-address">${location}</address>
              </div>
            </label>
          </li>
        `;
        const item = template.content.firstElementChild;
        if (!isAvailable) {
          item.querySelector(".select-store-input").remove();
          item.querySelector(".fake-checkbox").remove();
          item.querySelector(".pickup-availability-preview").innerHTML =
            '<span style="color: red;"> Pickup currently unavailable</span>';
        }

        if (!source) return item.outerHTML;

        const result = source.cloneNode(true);
        result.dataset.siteup = String(outlet?.site_code || source.dataset.siteup || "").trim();
        const previousInput = result.querySelector(".select-store-input");
        const pickupTime = previousInput?.dataset.pickuptime;
        previousInput?.remove();
        result.querySelector(".fake-checkbox")?.remove();
        result.querySelector(".pickup-availability-preview").replaceWith(
          item.querySelector(".pickup-availability-preview"),
        );

        if (isAvailable) {
          const input = item.querySelector(".select-store-input");
          input.value = result.dataset.storeName;
          input.dataset.siteup = result.dataset.siteup;
          if (pickupTime) input.dataset.pickuptime = pickupTime;
          result.querySelector(".store-item-label").prepend(input);
          result.querySelector("h3").prepend(item.querySelector(".fake-checkbox"));
        }

        return result.outerHTML;
      }
      getInventoryEntry(data, sku) {
        return (
          data?.items?.find?.((item) => item?.sku === sku) ||
          data?.data?.items?.find?.((item) => item?.sku === sku) ||
          data?.results?.find?.((item) => item?.sku === sku) ||
          data?.data?.results?.find?.((item) => item?.sku === sku) ||
          (data && Object.prototype.hasOwnProperty.call(data, sku)
            ? {
                sku,
                inventory:
                  typeof data[sku] === "object" && data[sku] !== null
                    ? (data[sku].inventory ?? data[sku].available)
                    : data[sku],
                is_available:
                  typeof data[sku] === "object" && data[sku] !== null
                    ? (data[sku].is_available ?? data[sku].available)
                    : Number(data[sku]) > 0,
              }
            : null) ||
          data
        );
      }
      getInventoryQuantity(entry) {
        const quantity = Number(entry?.inventory ?? entry?.available ?? entry);
        return Number.isFinite(quantity) ? quantity : 0;
      }
      async updateHomeDeliveryStatus() {
        if (this.dataset.pickupOnly === "true") return;

        const sku = String(this.dataset.sku || "").trim();
        const statusEl = this.querySelector("[data-home-delivery-status]");
        const textEl = this.querySelector("[data-home-delivery-text]");

        if (!statusEl || !textEl || !sku) return;

        statusEl.hidden = false;
        textEl.textContent = "Checking home delivery...";

        try {
          const res = await fetch(
            "https://shopify-big.bigcaring.com.my/api/outlet/check-inventory/shopify",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                skus: [sku],
              }),
            },
          );

          const data = await res.json();
          const inventory = this.getInventoryQuantity(
            this.getInventoryEntry(data, sku),
          );

          if (inventory <= 0) {
            textEl.textContent = "Unavailable for Home Delivery.";
          } else if (inventory <= 10) {
            textEl.textContent = `Home Delivery: Only ${inventory} left`;
          } else {
            textEl.textContent = "Home Delivery Available";
          }
        } catch (error) {
          console.error("home delivery inventory error:", error);
          textEl.textContent = "Unavailable for Home Delivery.";
        }
      }
      async updatePickupText() {
        const saved = localStorage.getItem("selectedStore");

        if (!saved) return;

        let store;
        try {
          store = JSON.parse(saved);
        } catch (e) {
          return;
        }

        // ✅ 作用域限定在当前组件
        const container = this.querySelector(".pickup-availability-info");
        if (!container) return;

        const defaultEl = container.querySelector(".pickup-default");
        const availableEl = container.querySelector(".pickup-available");
        const unavailableEl = container.querySelector(".pickup-unavailable");

        if (!availableEl || !unavailableEl) return;

        const availableText = availableEl.querySelector(".caption-large");
        const unavailableText = unavailableEl.querySelector(".caption-large");

        // ✅ 替换门店名
        if (store.name) {
          if (availableText?.dataset.template) {
            availableText.innerHTML = availableText.dataset.template.replace(
              "[[location]]",
              store.name,
            );
          }

          if (unavailableText?.dataset.template) {
            unavailableText.innerHTML =
              unavailableText.dataset.template.replace(
                "[[location]]",
                store.name,
              );
          }
        }

        // ✅ SKU 从组件拿（不要全局）
        const sku = this.dataset.sku;
        if (!sku) return;

        try {
          const res = await fetch(
            "https://shopify-big.bigcaring.com.my/api/outlet/check-inventory/local",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                skus: [sku],
                quantities: {
                  [sku]: 1,
                },
                site_code: store.siteup,
              }),
            },
          );

          const data = await res.json();
          const inventoryEntry = this.getInventoryEntry(data, sku);
          const inventory = this.getInventoryQuantity(inventoryEntry);
          const hasExplicitAvailability =
            inventoryEntry?.is_available !== undefined ||
            typeof inventoryEntry?.available === "boolean";
          const isAvailable = hasExplicitAvailability
            ? Boolean(inventoryEntry?.is_available ?? inventoryEntry?.available)
            : Number.isFinite(inventory) && inventory > 0;
          // ✅ 隐藏 Shopify 默认
          if (defaultEl) defaultEl.style.display = "none";

          // ✅ 控制显示
          if (isAvailable) {
            availableEl.style.display = "block";
            unavailableEl.style.display = "none";
          } else {
            availableEl.style.display = "none";
            unavailableEl.style.display = "block";
          }
        } catch (err) {
          console.error("pickup inventory error:", err);
        }
      }
    },
  );
}

/* =========================
   Drawer
========================= */
if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button")?.addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (e) => {
          if (e.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      handleBodyClick(evt) {
        if (
          evt.target != this &&
          !evt.target.closest("pickup-availability-drawer")
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
      }

      show() {
        this.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");
      }
    },
  );
}
